import React from 'react';

const DeviceManage = () => {
  return <div>设备管理</div>
}

export default DeviceManage;
